import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTableModule } from 'ng-zorro-antd/table';
import { finalize, Subject, takeUntil } from 'rxjs';
import { ApiResponses } from '../../../core/models/common.models';
import { AuthService } from '../../../core/services/auth.service';
import { ReturnUrlService } from '../../../core/services/return-url.service';
import { OrganizationService } from '../../../features/organizations/organization.service';
import { CommonService } from '../../../shared/services/common.service';
import {
  OrganizationDetailModel,
  OrganizationModel,
} from '../../organizations/organization.interface';
import { UserDatePipe } from '../../../shared/pipes/user-date.pipe';

@Component({
  selector: 'app-switch-user',
  standalone: true,
  imports: [NzTableModule, NzButtonModule, CommonModule, UserDatePipe],
  templateUrl: './switch-user.component.html',
  styleUrl: './switch-user.component.scss',
})
export class SwitchUserComponent implements OnInit, OnDestroy {
  loader = false;
  organizations: OrganizationModel[] = [];
  orgData: OrganizationDetailModel | null = null;
  private readonly destroy$ = new Subject<void>();
  private readonly USER_KEY = 'user_data';
  listOfColumn = [
    {
      title: 'School Name',
    },
    {
      title: 'Last Login',
    },
    {
      title: 'Status',
    },
    {
      title: '',
    },
  ];

  constructor(
    private organizationService: OrganizationService,
    private commonService: CommonService,
    private authService: AuthService,
    private returnUrlService: ReturnUrlService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.authService.orgData$.subscribe(res => {
      this.orgData = res;
    });
  }

  ngOnInit(): void {
    this.getOrganizations();
    const urlReturn = this.route.snapshot.queryParams['returnUrl'];
    if (urlReturn) {
      this.returnUrlService.setReturnUrl(urlReturn);
    }
  }
  getOrganizations() {
    this.loader = true;
    this.organizationService
      .getOrganizationsToSwitch()
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.loader = false;
        })
      )
      .subscribe({
        next: (res: ApiResponses<OrganizationModel>) => {
          this.organizations = res ? res.result : [];
          if (this.organizations.length === 1) {
            this.switch(this.organizations[0].id);
          }
        },
        error: (error: Error) => {
          this.commonService.notify('error', error.message);
        },
      });
  }

  switch(orgId?: number) {
    if (orgId) {
      this.loader = true;
      this.organizationService
        .switchOrganization(orgId)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => {
            this.loader = false;
          })
        )
        .subscribe({
          next: res => {
            const orgData = this.authService.encryptData(res.result);
            localStorage.setItem('Selected_Org_Data', orgData);
            this.orgData = res.result;
            // const token =
            //   res && res.result && res.result.token ? res.result?.token : '';
            // this.authService.updateToken(token);
            this.authService.orgData.next(res.result);
            const user = localStorage.getItem(this.USER_KEY);
            if (user) {
              this.authService.userData.next(
                this.authService.decryptData(user)
              );
            }
            // Wait for setRole to complete before redirecting
            this.authService.setRole(res.result?.user?.roles || []).then(() => {
              this.authService.logoutLMS();
              const returnUrl = this.returnUrlService.getReturnUrl();
              this.returnUrlService.clearReturnUrl();
              window.location.href = returnUrl
                ? returnUrl !== this.router.url
                  ? returnUrl
                  : '/dashboard'
                : '/dashboard';
              //this.router.navigateByUrl(returnUrl);
            });
          },
          error: (error: Error) => {
            this.loader = false;
            this.commonService.notify('error', error.message);
          },
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
